import { ErrorPageDetailsTypes } from '@/types/errorPageDetailsTypes';

export const errorPageDetailsConstant: ErrorPageDetailsTypes = {
  description:
    'Ups, etwas ist schief gelaufen. Bitte versuchen Sie es etwas später erneut.',
  title: 'Systemfehler',
};
